const getModuleState = (state) => state.logs;

export const getLogs = (state) => getModuleState(state).pageLogs;
export const getRequests = (state) => getModuleState(state).userRequests;
export const getReports = (state) => getModuleState(state).pageReports;
export const getNotFound = (state) => getModuleState(state).pageNotFound;